import gql from 'graphql-tag';

export const addUdalost = gql`
  mutation addUdalost($input: [UdalostInput!]!) {
    response: addUdalost(inputUdalost: $input) {
      id
    }
  }
`;
